(function(){
  'use strict';
  var drawer=document.querySelector('[data-sp-cd]');
  if(!drawer)return;
  var scrim=document.querySelector('[data-sp-cd-scrim]');
  var symbol=drawer.getAttribute('data-symbol')||'$';
  var threshold=parseInt(drawer.getAttribute('data-threshold')||'0',10);
  var fsOn=drawer.getAttribute('data-fs')==='1';
  function money(c){return symbol+(c/100).toFixed(2)}
  function esc(s){var d=document.createElement('div');d.textContent=s==null?'':String(s);return d.innerHTML}
  function setBadges(n){
    var badges=document.querySelectorAll('.sp-cart-count');
    if(n>0&&badges.length===0){
      var t=document.querySelector('[data-sp-cart-toggle]');
      if(t){var s=document.createElement('span');s.className='sp-cart-count';t.appendChild(s);badges=document.querySelectorAll('.sp-cart-count')}
    }
    badges.forEach(function(el){if(n===0){el.remove()}else{el.textContent=n}});
  }
  function render(cart){
    setBadges(cart.item_count);
    drawer.querySelector('[data-sp-cd-count]').textContent='('+cart.item_count+')';
    var items=drawer.querySelector('[data-sp-cd-items]');
    var empty=drawer.querySelector('[data-sp-cd-empty]');
    var foot=drawer.querySelector('[data-sp-cd-foot]');
    var ship=drawer.querySelector('[data-sp-cd-ship]');
    if(cart.item_count===0){items.innerHTML='';empty.hidden=false;foot.hidden=true;ship.hidden=true;return}
    empty.hidden=true;foot.hidden=false;
    var html='';
    cart.items.forEach(function(it,i){
      var img=it.image?('<img src="'+it.image+'" alt="" loading="lazy">'):'<span></span>';
      var vt=(it.variant_title&&it.variant_title!=='Default Title')?('<p class="sp-cd__ivar">'+esc(it.variant_title)+'</p>'):'';
      html+='<div class="sp-cd__item">'
        +'<div>'+img+'</div>'
        +'<div><p class="sp-cd__ititle">'+esc(it.product_title)+'</p>'+vt
        +'<div class="sp-cd__qty"><button type="button" data-sp-cd-minus data-line="'+(i+1)+'" data-qty="'+it.quantity+'" aria-label="Decrease quantity">\u2212</button><span>'+it.quantity+'</span><button type="button" data-sp-cd-plus data-line="'+(i+1)+'" data-qty="'+it.quantity+'" aria-label="Increase quantity">+</button></div>'
        +'<button type="button" class="sp-cd__remove" data-sp-cd-remove data-line="'+(i+1)+'">Remove</button></div>'
        +'<div class="sp-cd__iprice">'+money(it.final_line_price)+'</div>'
        +'</div>';
    });
    items.innerHTML=html;
    drawer.querySelector('[data-sp-cd-subtotal]').textContent=money(cart.items_subtotal_price);
    if(fsOn&&threshold>0){
      ship.hidden=false;
      var total=cart.items_subtotal_price;
      var pct=Math.min(100,Math.round(total/threshold*100));
      drawer.querySelector('[data-sp-cd-barfill]').style.width=pct+'%';
      var msg=drawer.querySelector('[data-sp-cd-shipmsg]');
      if(total>=threshold){msg.innerHTML='<strong>You unlocked FREE shipping!</strong>'}
      else{msg.innerHTML='Spend <strong>'+money(threshold-total)+'</strong> more for <strong>FREE shipping</strong>!'}
    }else{ship.hidden=true}
  }
  function refresh(){return fetch('/cart.js').then(function(r){return r.json()}).then(render)}
  function open(){drawer.classList.add('is-open');scrim.classList.add('is-open');document.documentElement.classList.add('sp-lock');drawer.setAttribute('aria-hidden','false');refresh()}
  function close(){drawer.classList.remove('is-open');scrim.classList.remove('is-open');document.documentElement.classList.remove('sp-lock');drawer.setAttribute('aria-hidden','true')}
  function change(line,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json()}).then(render);
  }
  document.addEventListener('click',function(e){
    var t;
    if(e.target.closest('[data-sp-cart-toggle]')){e.preventDefault();open();return}
    if(e.target.closest('[data-sp-cd-close]')||e.target===scrim){close();return}
    t=e.target.closest('[data-sp-cd-plus]');
    if(t){change(parseInt(t.getAttribute('data-line'),10),parseInt(t.getAttribute('data-qty'),10)+1);return}
    t=e.target.closest('[data-sp-cd-minus]');
    if(t){change(parseInt(t.getAttribute('data-line'),10),parseInt(t.getAttribute('data-qty'),10)-1);return}
    t=e.target.closest('[data-sp-cd-remove]');
    if(t){change(parseInt(t.getAttribute('data-line'),10),0);return}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||!f.getAttribute)return;
    var a=f.getAttribute('action')||'';
    if(a.indexOf('/cart/add')===-1)return;
    e.preventDefault();e.stopPropagation();
    var btn=f.querySelector('[type="submit"]');
    if(btn){btn.classList.add('is-loading');btn.disabled=true}
    fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()})
      .then(function(res){
        if(btn){btn.classList.remove('is-loading');btn.disabled=false}
        if(res&&res.status&&res.message){window.alert(res.description||res.message);return}
        open();
      })
      .catch(function(){if(btn){btn.classList.remove('is-loading');btn.disabled=false}});
  },true);
  refresh();
})();
